export default "__VITE_ASSET__6e94e560__"